import {
  Button,
  Form,
  Input,
  Modal,
  Popconfirm,
  Select,
  Skeleton,
  Space,
  Table,
  Tag,
} from "antd";
import { useState } from "react";

import { Caracteristicas } from "../../interfaces/Caracteristicas";
import { Container, ContainerTitulo, TituloForm } from "../ViewGerenciar/styles";
import {
  EscopoCaracteristicaAdmin,
  useGerenciarCaracteristicas,
} from "./hooks/useGerenciarCaracteristicas";

type FormValues = {
  nome: string;
  escopo: EscopoCaracteristicaAdmin;
};

const opcoesEscopo = [
  { value: "AMBOS", label: "Ambos" },
  { value: "EMPREENDIMENTO", label: "Empreendimento" },
  { value: "APARTAMENTO", label: "Apto" },
];

const escopoLabel: Record<EscopoCaracteristicaAdmin, string> = {
  AMBOS: "Ambos",
  EMPREENDIMENTO: "Empreendimento",
  APARTAMENTO: "Apto",
};

const escopoColor: Record<EscopoCaracteristicaAdmin, string> = {
  AMBOS: "gold",
  EMPREENDIMENTO: "blue",
  APARTAMENTO: "green",
};

export default function ViewGerenciarCaracteristicas() {
  const {
    caracteristicas,
    loading,
    savingId,
    deletingId,
    adding,
    contextHolder,
    atualizarCampo,
    salvarCaracteristica,
    adicionarCaracteristica,
    removerCaracteristica,
  } = useGerenciarCaracteristicas();
  const [modalOpen, setModalOpen] = useState(false);
  const [form] = Form.useForm<FormValues>();

  const fecharModal = () => {
    setModalOpen(false);
    form.resetFields();
  };

  const handleAdicionar = async () => {
    const values = await form.validateFields();
    const created = await adicionarCaracteristica(values);

    if (created) {
      fecharModal();
    }
  };

  const columns = [
    {
      title: "Nome",
      dataIndex: "nome",
      width: "45%",
      render: (text: string, record: Caracteristicas) => (
        <Input
          value={record.nome}
          onChange={(e) => atualizarCampo(record.id, "nome", e.target.value)}
          placeholder="Nome da característica"
        />
      ),
    },
    {
      title: "Tipo",
      dataIndex: "escopo",
      width: "25%",
      render: (value: EscopoCaracteristicaAdmin, record: Caracteristicas) => (
        <Select
          value={record.escopo || "AMBOS"}
          options={opcoesEscopo}
          style={{ width: "100%" }}
          onChange={(novoValor) =>
            atualizarCampo(record.id, "escopo", novoValor)
          }
          optionRender={(option) => (
            <Tag color={escopoColor[option.value as EscopoCaracteristicaAdmin]}>
              {option.label}
            </Tag>
          )}
        />
      ),
    },
    {
      title: "Visualização",
      dataIndex: "escopoTag",
      width: "15%",
      render: (_: unknown, record: Caracteristicas) => {
        const escopo = (record.escopo || "AMBOS") as EscopoCaracteristicaAdmin;

        return <Tag color={escopoColor[escopo]}>{escopoLabel[escopo]}</Tag>;
      },
    },
    {
      title: "Ações",
      width: "15%",
      render: (_: unknown, record: Caracteristicas) => (
        <Space size="small">
          <Button
            type="primary"
            loading={savingId === record.id}
            onClick={() => salvarCaracteristica(record)}
          >
            Salvar
          </Button>
          <Popconfirm
            title="Excluir característica"
            description="Deseja realmente excluir esta característica?"
            okText="Excluir"
            cancelText="Cancelar"
            onConfirm={() => removerCaracteristica(record.id)}
          >
            <Button danger loading={deletingId === record.id}>
              Excluir
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Container>
      {contextHolder}

      <ContainerTitulo>
        <TituloForm>Características</TituloForm>
      </ContainerTitulo>

      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          padding: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
            marginBottom: "20px",
          }}
        >
          <div>
            <h1 style={{ marginBottom: "8px" }}>Características</h1>
            <p style={{ margin: 0, color: "#4b5563" }}>
              Edite o nome e o tipo das características cadastradas no sistema.
            </p>
          </div>

          <Button type="primary" onClick={() => setModalOpen(true)}>
            Adicionar característica
          </Button>
        </div>

        {loading ? (
          <Skeleton active />
        ) : (
          <Table
            rowKey="id"
            columns={columns}
            dataSource={caracteristicas}
            pagination={false}
            scroll={{ x: 900 }}
          />
        )}
      </div>

      <Modal
        title="Adicionar característica"
        open={modalOpen}
        onCancel={fecharModal}
        onOk={handleAdicionar}
        okText="Adicionar"
        cancelText="Cancelar"
        confirmLoading={adding}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{ escopo: "AMBOS" }}
        >
          <Form.Item
            label="Nome"
            name="nome"
            rules={[
              { required: true, message: "Informe o nome da característica" },
            ]}
          >
            <Input placeholder="Ex.: Vista para o mar" />
          </Form.Item>

          <Form.Item
            label="Tipo"
            name="escopo"
            rules={[{ required: true, message: "Selecione o tipo" }]}
          >
            <Select options={opcoesEscopo} />
          </Form.Item>
        </Form>
      </Modal>
    </Container>
  );
}
